import { HOTSPOT_LABEL_THEME, HOTSPOT_THEME_CONFIGS } from 'constants';

/**
 * Get the label theme for a hotspot
 * @param {number} theme - The theme of the hotspot
 * @param {string} primaryColor - The primary color of the hotspot
 * @param {boolean} darkMode - Whether the hotspot is in dark mode
 * @returns {object} The label theme for the hotspot
 */
export const getLabelTheme = (theme, primaryColor, darkMode = false) => {
  const themeValue = parseInt(theme);

  const config = HOTSPOT_THEME_CONFIGS[themeValue] || HOTSPOT_THEME_CONFIGS[HOTSPOT_LABEL_THEME.DEFAULT];
  const backgroundColor = config.usePrimaryColor && primaryColor ? primaryColor : config.backgroundColor;

  // hotspots' `darkmode` prop still affects title color
  // need to ensure title text color matches darkmode prop when default theme is used
  let textColor = config.textColor;
  if (themeValue === HOTSPOT_LABEL_THEME.DEFAULT) {
    textColor = darkMode ? '#000000' : '#ffffff';
  }

  return {
    textColor,
    backgroundColor,
  };
};
